import {
  SignalRNotification,
  SystemMappingNotification,
} from "src/globalTypes";

export const getSystemNotificationIdsToResolve = (
  systemNotifications: SystemMappingNotification[],
  dataSourceId: number
) =>
  systemNotifications
    .filter(({ type }) => type === "mapping")
    .filter((notification) => notification.datasourceId === dataSourceId)
    .map(({ notificationId }) => notificationId);

export const removeReadNotifs = (notif: SignalRNotification) => !notif.isRead;

export const parseNotifications = <T>(notifications: string[]): T[] =>
  notifications.map((notification) => JSON.parse(notification) as T);
